import { Injectable } from '@angular/core';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { EventsType } from '@monsido/services/mon-event/events.type';
import { SessionService } from '@monsido/core/session/session.service';
import { ActiveChatService } from '../services/active-chat.service';
import { chatSystems } from '@monsido/core/constants/general.constant';
import { ChatConfigService } from '@client/app/modules/chat/services/chat-config.service';

@Injectable({
    providedIn: 'root',
})
export class ChatRunService {
    constructor (
        private monEventService: MonEventService,
        private sessionService: SessionService,
        private activeChatService: ActiveChatService,
        private chatConfigService: ChatConfigService,
    ) {}

    initialize (): Promise<void> {
        return new Promise((resolve) => {
            try {
                this.setupEventListeners();
                resolve();
            } catch {
                // Error will be caught by Angular's error handling
                resolve();
            }
        });
    }

    private setupEventListeners (): void {
        // Proper event names are 'exitCustomer' and 'setAccount' based on other usages
        this.monEventService.addListener('exitCustomer' as EventsType, () => {
            this.sessionService.resetChatSystems();
        });

        this.monEventService.addListener('setAccount' as EventsType, () => {
            const chat = this.activeChatService.getActiveChat();
            this.sessionService.setChatSystem(chat.system, chat.options);
            this.chatConfigService.setConfig(chatSystems);
        });
    }
}
